import ReactMarkdown from "react-markdown";
import { useContentRendererStyles } from "./content-renderer.styles";
import { ContentRendererProps } from "../types/index";
import { cx } from "antd-style";

export const ContentRenderer = ({
  content,
  type,
  className,
  markdownComponents,
}: ContentRendererProps) => {
  const { styles } = useContentRendererStyles();

  if (!content) {
    return null;
  }

  return (
    <div className={cx(styles.root, className)}>
      {type === "html" && <div dangerouslySetInnerHTML={{ __html: content }} />}
      {type === "md" && (
        <ReactMarkdown components={markdownComponents}>{content}</ReactMarkdown>
      )}
    </div>
  );
};
